import { useState } from 'react'
import { cn } from '@/lib/utils'
import { detectVariantClasses } from './utils'

/** Editable raw className — click to focus textarea */
export function EditableClassField({
  value,
  onChange,
  elementType,
}: {
  value: string
  onChange: (value: string) => void
  elementType?: string
}) {
  const [draft, setDraft] = useState(value)
  const [focused, setFocused] = useState(false)

  // Sync draft when value changes externally
  if (!focused && draft !== value) {
    setDraft(value)
  }

  const variantTokens = detectVariantClasses(draft)

  return (
    <div>
      <textarea
        className={cn(
          'w-full font-mono text-xs break-all rounded px-1.5 py-1 resize-none transition-colors',
          focused
            ? 'bg-muted/70 border border-input focus:outline-none focus:ring-1 focus:ring-ring'
            : 'bg-muted/50 border border-transparent hover:border-input cursor-text',
        )}
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onFocus={() => setFocused(true)}
        onBlur={() => {
          setFocused(false)
          if (draft !== value) onChange(draft)
        }}
        onKeyDown={(e) => {
          if (e.key === 'Escape') {
            setDraft(value)
              ; (e.target as HTMLElement).blur()
          }
        }}
        rows={2}
      />
      {variantTokens.length > 0 && (
        <div className="text-[10px] text-amber-500 mt-0.5 leading-tight">
          Variant classes detected: {variantTokens.join(', ')}. Use the Variant/Size dropdown instead.
        </div>
      )}
    </div>
  )
}
